interface SupplierPayment {
	amountCents: number;
	direction: "DEBIT" | "CREDIT";
	supplier: {
		id: string;
		name: string;
		category: { id: string; name: string };
	} | null;
}

export const SupplierPayments = {
	summarize(transactions: SupplierPayment[], categoryId?: string) {
		const totals = new Map<
			string,
			{
				supplierId: string;
				supplierName: string;
				categoryId: string;
				categoryName: string;
				transactionCount: number;
				amountCents: number;
			}
		>();

		for (const transaction of transactions) {
			if (
				transaction.direction !== "DEBIT" ||
				!transaction.supplier ||
				(categoryId && transaction.supplier.category.id !== categoryId)
			) {
				continue;
			}

			const current = totals.get(transaction.supplier.id);

			totals.set(transaction.supplier.id, {
				supplierId: transaction.supplier.id,
				supplierName: transaction.supplier.name,
				categoryId: transaction.supplier.category.id,
				categoryName: transaction.supplier.category.name,
				transactionCount: (current?.transactionCount ?? 0) + 1,
				amountCents: (current?.amountCents ?? 0) + Math.abs(transaction.amountCents),
			});
		}

		return [...totals.values()].toSorted((left, right) => right.amountCents - left.amountCents);
	},
};
